import { Capacitor } from '@capacitor/core';

// Retrieves the environment config for upload methods:-
export function getEnvironmentConfig(){
    const appUrl = window.location.hostname;
    let isProduction = false;
    
    // Check if running in Capacitor (native app)
    if (Capacitor.isNativePlatform()) {
        // For native apps, check multiple indicators for production
        // 1. Check if VUE_APP_MODE environment variable was set during build
        if (process.env.VUE_APP_MODE === 'production' || process.env.VUE_APP_MODE === 'staging') {
            isProduction = true;
        }
        // 2. Check if the app ID matches production app ID
        else if (Capacitor.getConfig && Capacitor.getConfig().appId === 'com.agentos.myprop') {
            isProduction = true;
        }
        // 3. Fallback: check URL (though this may not work in all native scenarios)
        else if (window.location.href.includes('www.myprop.app') || window.location.href.includes('staging.myprop.app')) {
            isProduction = true;
        }
        // 4. Default to production for release builds (safer than defaulting to test)
        else if (!window.location.href.includes('localhost') && !window.location.href.includes('10.0.2.2')) {
            isProduction = true;
        }
    } else {
        // Web app: use hostname-based detection
        isProduction = appUrl === 'www.myprop.app' || appUrl === 'staging.myprop.app';
    }
    
    const config = {
        baseURL: isProduction ? 'https://live-api.letmc.com' : 'https://test2-api.letmc.com',
        apiKey: isProduction ? 'YoBOy5-1a-MLZ4YCwpMPoKVwMr_OznIdYE-WGURAZ-o1' : 'yrR5n2TUHYH44ybHgYhGdre5k-ze6fUwLI7UTNzKjuI1'
    };
    
    // Log configuration for debugging (development only)
    if (process.env.NODE_ENV === 'development') {
        console.log('Environment Config:', {
            hostname: appUrl,
            isNative: Capacitor.isNativePlatform(),
            isProduction,
            baseURL: config.baseURL,
            appId: Capacitor.getConfig ? Capacitor.getConfig().appId : 'unknown',
            mode: process.env.VUE_APP_MODE || 'not set'
        });
    }

    return config;
}